import { ConditionalPartial } from '../../../../utils';
import { CreateWarehouseDetailsRequestDto } from './create-warehouse-details.request.dto';

/**
 * DTO for updating warehouse details
 * All fields are optional for partial updates
 */
export class UpdateWarehouseDetailsRequestDto extends ConditionalPartial(CreateWarehouseDetailsRequestDto) {}
